import * as redux from 'redux';
import ngRedux from 'ng-redux';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import ngAnimate from 'angular-animate';
import ngAside from 'angular-aside';
import toaster from 'angularjs-toaster';
import ngCookies from 'angular-cookies';
import ngMessages from 'angular-messages';
import uiMask from 'angular-ui-mask';
import angularSpinners from 'angular-spinners';
import ngMap from 'ngmap';
import tooltips from 'angular-tooltips';
import ngMeta from 'ng-meta';
import 'angular-sanitize';
import 'angularjs-dropdown-multiselect';


// Router
import { routerConfig } from './router';

// Apps
import { AppComponent } from './app';

// Reducers
import auth from './app/auth/reducer';
import order from './app/order/reducer';

// Constants
import appConstants from './constants';

// Styles
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/angular-aside/dist/css/angular-aside.min.css';
import './../node_modules/angularjs-toaster/toaster.min.css';
import './../node_modules/angular-tooltips/dist/angular-tooltips.min.css';
import './styles/styles.css';

/*eslint-disable*/
import authApp from './app/auth/main';
import dashboardApp from './app/dashboard/main';
import orderApp from './app/order/main';
import components from './app/components/main';
/*eslint-enable*/

const reducers = redux.combineReducers({
  auth,
  order,
  ngMeta
});

var angular = require('angular');
require('angulartics');
var googleanalaytics = require('angulartics-google-analytics');
var remarketing = require('angulartics-google-adwords-remarketing-tag');

let app = angular.module('app', [
  ngRedux,
  uiRouter,
  uiBootstrap,
  ngAnimate,
  ngAside,
  toaster,
  ngCookies,
  ngMessages,
  uiMask,
  ngMap,
  angularSpinners,
  'angularjs-dropdown-multiselect',
  'angulartics',
  googleanalaytics,
  remarketing,
  'app.components',
  'app.auth',
  'app.dashboard',
  'app.order',
  tooltips,
  'ngMeta',
  'ngSanitize'
]).run(['$anchorScroll','ngMeta','$rootScope', function($anchorScroll,ngMeta) {
  console.log("Heartland ", window.Heartland);
  console.log("Tsys ", window.GlobalPayments);
  console.log("Moneris", window.monerisCheckout);
      $anchorScroll.yOffset = 350;   // always scroll by 50 extra pixels
      // console.log(ngMeta);
      ngMeta.init();
    }])

  .constant('APP', appConstants)

  .constant('Heartland', window.Heartland)

  .constant('POWERREVIEWS', window.POWERREVIEWS)
  .constant('GlobalPayments', window.GlobalPayments)
  // .constant('paypal', window.paypal)

  .constant('MonerisCheckout', window.monerisCheckout)

  .component('app', AppComponent)

  .config(routerConfig)

  .config(['$ngReduxProvider', $ngReduxProvider => {

    $ngReduxProvider.createStoreWith(reducers);
  }])
  .config(['$analyticsProvider', $analyticsProvider => {
    $analyticsProvider.firstPageview(true);
    $analyticsProvider.withAutoBase(true);
  }]);

angular.element(document).ready(() => {
  angular.bootstrap(document, [app.name], {strictDi: true});
});



// WEBPACK FOOTER //
// ./src/main.js